import { styled } from 'styled-components';

import { BreakPoints } from 'styles/createBreakpoints';

import { DisplayType } from 'interfaces/styles';

interface MedaQueryProps {
  $min?: BreakPoints;
  $max?: BreakPoints;
  $minCustom?: string;
  $maxCustom?: string;
  $display?: DisplayType;
  $mobile?: boolean;
  $desktop?: boolean;
}

// You can simply pass $mobile or $desktop
// You can pass a layout breakpoint to $min and $max. ex: $min='lg'
// Alternatively, if you need a custom breakpoint, you can pass one in using $minCustom and $maxCustom. ex: $maxCustom='1000px'
export const MediaQuery = styled.div<MedaQueryProps>`
  ${(props) => `
    display: none;

    ${
      props.$mobile &&
      `
      display: none;

      @media (max-width: ${props.theme.breakpoints.lg}) {
        display: ${props.$display ?? 'block'};
      }
    `
    };

    ${
      props.$desktop &&
      `
      display: ${props.$display ?? 'block'};

      @media (max-width: ${props.theme.breakpoints.lg}) {
        display: none;
      }
    `
    };

    ${
      props.$min &&
      `
      @media (min-width: ${props.theme.breakpoints[props.$min]}) {
        display: ${props.$display ?? 'block'};
      }
    `
    };

    ${
      props.$minCustom &&
      `
      @media (min-width: ${props.$minCustom}}) {
        display: ${props.$display ?? 'block'};
      }
    `
    };

    ${
      props.$max &&
      `
      @media (max-width: ${props.theme.breakpoints[props.$max]}) {
        display: ${props.$display ?? 'block'};
      }
    `
    };

    ${
      props.$maxCustom &&
      `
      @media (max-width: ${props.$maxCustom}) {
        display: ${props.$display ?? 'block'};
      }
    `
    };

  `}
`;
